import { useState } from "react";
import { GlobovmsLogo } from "../brand/GlobovmsLogo";

const links = [
  ["Product", "#overview"],
  ["How it works", "#lifecycle"],
  ["Industries", "#industries"],
  ["Integrations", "#integrations"],
];

export function Navbar() {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-30 border-b border-slate-200/70 bg-white/80 backdrop-blur-xl">
      <div className="mx-auto flex h-[4.25rem] max-w-7xl items-center justify-between gap-6 px-5">
        <a href="#top" aria-label="globoVMS home" onClick={() => setOpen(false)} className="shrink-0">
          <GlobovmsLogo />
        </a>
        <nav className="hidden items-center gap-0.5 lg:flex" aria-label="Primary">
          {links.map(([label, to]) => (
            <a
              key={to}
              href={to}
              className="rounded-full px-2.5 py-1.5 text-base font-semibold text-slate-600 transition-colors duration-200 hover:bg-slate-100 hover:text-brand-ink"
            >
              {label}
            </a>
          ))}
        </nav>
        <div className="flex items-center gap-2">
          <a href="#demo" className="inline-flex items-center justify-center rounded-full bg-brand-orange px-4 py-2 text-base font-semibold text-white hover:bg-[#c4631d]">Request a demo</a>
          <button
            type="button"
            className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-slate-200 text-brand-ink lg:hidden"
            aria-expanded={open}
            aria-controls="mobile-nav"
            aria-label={open ? "Close menu" : "Open menu"}
            onClick={() => setOpen((value) => !value)}
          >
            <span className="relative block h-3 w-4">
              <span className={`absolute left-0 h-0.5 w-4 bg-current transition-transform duration-200 ${open ? "top-1.5 rotate-45" : "top-0"}`} />
              <span className={`absolute left-0 top-1.5 h-0.5 w-4 bg-current transition-opacity duration-200 ${open ? "opacity-0" : "opacity-100"}`} />
              <span className={`absolute left-0 h-0.5 w-4 bg-current transition-transform duration-200 ${open ? "top-1.5 -rotate-45" : "top-3"}`} />
            </span>
          </button>
        </div>
      </div>
      <div id="mobile-nav" className={`grid transition-[grid-template-rows] duration-300 lg:hidden ${open ? "grid-rows-[1fr]" : "grid-rows-[0fr]"}`}>
        <nav className="overflow-hidden" aria-label="Mobile">
          <div className="mx-5 mb-4 grid gap-1 rounded-xl border border-slate-200 bg-white p-2 shadow-sm">
            {links.map(([label, to]) => (
              <a
                key={to}
                href={to}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-2.5 text-sm font-semibold text-slate-700"
              >
                {label}
              </a>
            ))}
          </div>
        </nav>
      </div>
    </header>
  );
}
